exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".action[data-v-4826c84f]{width:5px}.middle-alignment[data-v-4826c84f]{display:flex;align-items:center;justify-content:flex-start}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4826c84f&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/customer/CustomerTable.vue
// module id = 587
// module chunks = 0